import React from "react";
import withAnimation from "../../../hooks/withAnimation";
import { doctorHomeImages } from "../../../config";
import { useNavigate } from "react-router-dom";

const BlogDetailSection = ({ blog, relatedBlogs = [] }) => {
  const navigate = useNavigate()
  return (
    <section className="container mx-auto py-16 px-4 lg:px-20">
      {/* Blog Header */}
      <div className="text-center mb-12">
        <h1 className="text-3xl text-start font-bold text-primary mb-4 lg:text-5xl">{blog.title}</h1>
        <p className=" text-sm text-start text-gray-600 lg:text-lg">{blog.excerpt}</p>
      </div>

      {/* Blog Image with Overlay */}
      <div className="relative mb-16 shadow-2xl rounded-lg overflow-hidden">
        <img
          src={blog.imageUrl}
          alt={blog.title}
          className="w-full h-auto object-cover transform hover:scale-105 transition-transform duration-700"
        />
        <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center text-white text-3xl font-bold opacity-0 hover:opacity-100 transition-opacity duration-500">
          {blog.title}
        </div>
      </div>

      {/* Blog Content with Stylish Typography */}
      <div className="prose prose-lg max-w-none text-gray-800 mx-auto lg:px-12 lg:py-8 leading-loose bg-white shadow-lg rounded-lg p-8">
        <h2 className="text-4xl font-extrabold text-primary mb-8">
          Introduction
        </h2>
        <div className="mb-12">
          <div className="prose text-justify prose-lg max-w-none text-gray-800 mb-6">
            <p>{blog.phase1Content}</p>
          </div>
          <div className="text-center">
            <img
              src={blog.phase1ImageUrl}
              alt="Phase 1"
              className="rounded-lg shadow-lg w-full h-auto"
            />
          </div>
        </div>
        <blockquote className="p-4 text-justify italic border-l-4 border-primary bg-gray-100 rounded-lg text-xl mb-8">
          "Rehabilitation is not just about physical recovery. It is a journey
          of rebuilding strength, resilience, and spirit."
        </blockquote>

        {/* Phase 2 - Active Recovery */}
        <div className="mb-12">
          <h2 className="text-3xl font-bold text-primary mb-6">
            Active Recovery
          </h2>
          <div className="prose text-justify prose-lg max-w-none text-gray-800 mb-6">
            <p>{blog.phase2Content}</p>
          </div>
          <div className="text-center">
            <img
              src={blog.phase2ImageUrl}
              alt="Phase 2"
              className="rounded-lg shadow-lg w-full h-auto"
            />
          </div>
        </div>

        {/* Phase 3 - Long-Term Maintenance */}
        <div className="mb-12">
          <h2 className="text-3xl font-bold text-primary mb-6">
            Long-Term Maintenance
          </h2>
          <div className="prose text-justify prose-lg max-w-none text-gray-800 mb-6">
            <p>{blog.phase3Content}</p>
          </div>
          <div className="text-center">
            <img
              src={blog.phase3ImageUrl}
              alt="Phase 3"
              className="rounded-lg shadow-lg w-full h-auto"
            />
          </div>
        </div>

        {/* Conclusion */}
        <div className="prose prose-lg max-w-none  text-gray-800">
          <p>{blog.conclusion}</p>
        </div>
        <p className="mb-6 text-justify">{blog.content}</p>
        <div className="mt-12 text-center">
          <a
            href="#related-posts"
            className="inline-block bg-primary text-white py-3 px-8 rounded-full font-semibold hover:bg-secondary transition duration-300"
          >
            Explore Related Blogs
          </a>
        </div>
      </div>

      {/* Author Section */}
      <div className="mt-12 flex items-center space-x-4">
        <img
          src={doctorHomeImages.doctor6}
          alt="Author"
          className="w-16 h-16 rounded-full"
        />
        <div>
          <h3 className="text-lg font-semibold text-primary">Dr. Paul Sidhu</h3>
          <p className="text-gray-600">Physiotherapist | Health Blogger</p>
        </div>
      </div>

      {/* Related Blogs */}
      <div className="mt-16">
        <h2 className="text-3xl font-bold text-primary mb-8">Related Blogs</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Blog Card */}
          {relatedBlogs.map((relatedBlog) => (
            <div
              key={relatedBlog.id}
              className="bg-white rounded-lg shadow-lg overflow-hidden"
            >
              <img
                src={relatedBlog.imageUrl}
                alt={relatedBlog.title}
                className="w-full h-40 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold text-primary mb-2">
                  {relatedBlog.title}
                </h3>
                <p className="text-gray-600">{relatedBlog.excerpt}</p>
                <a
                  onClick={()=>navigate(`/blog/${relatedBlog.id}`)}
                  className="text-secondary mt-4 inline-block"
                >
                  Read More
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default withAnimation(BlogDetailSection);
